module.exports = __webpack_public_path__ + "img/fakke2.d955364d.jpeg";